(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveListController', ReserveListController);

    ReserveListController.$inject = ['__config', '$scope', '$state', 'OrderBagServiceItem', 'CompanyCustomer', 'CompanyCustomerCustom', 'OrderBagServiceItemSearch', 'ParseLinks', 'InvoiceInfoCustom', 'AlertService', 'pagingParams', 'paginationConstants', '$translate', 'OrderBagServiceItemCustom', 'formMode', 'ServiceItemCustom', '$mdDialog', 'DateUtils', 'ServantCustom', 'CompanySubscriptionStatusCustom', 'DEFAULT_VIDEO_CALL_URL', '$window', 'Principal', '$uibModal', 'ProgressBarService', 'QueryParamsService', '$mdMedia'];

    function ReserveListController(__config, $scope, $state, OrderBagServiceItem, CompanyCustomer, CompanyCustomerCustom, OrderBagServiceItemSearch, ParseLinks, InvoiceInfoCustom, AlertService, pagingParams, paginationConstants, $translate, OrderBagServiceItemCustom, formMode, ServiceItemCustom, $mdDialog, DateUtils, ServantCustom, CompanySubscriptionStatusCustom, DEFAULT_VIDEO_CALL_URL, $window, Principal, $uibModal, ProgressBarService, QueryParamsService, $mdMedia) {
        var vm = this;
        vm.__config = __config;
        vm.formMode = formMode.mode;
        // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.findStatusTitle = findStatusTitle;
        vm.findStatusStyle = findStatusStyle;
        vm.searchOrderBag = searchOrderBag;
        vm.refresh = refresh;
        vm.getMonthCount = getMonthCount;
        vm.showSearchBoxOnMobile = showSearchBoxOnMobile;
        vm.searchBoxOnMobile = false;
        vm.serviceItem_changed = serviceItem_changed;
        vm.serviceItemId = "";
        vm.paymentLogs = [];
        vm.orderBagStatusList = null;
        vm.status_changed = status_changed;
        vm.orderBagStatus = "";
        vm.showDateSearch = showDateSearch;
        vm.showSearchByDates = false;
        vm.showSearchTextBoxOnMobile = showSearchTextBoxOnMobile;
        vm.searchTextBoxOnMobile = false;
        vm.searchOrderBagByQuery = searchOrderBagByQuery;
        vm.showIntakeData = showIntakeData;
        vm.reserveGatewayToPersian = reserveGatewayToPersian;
        vm.filterQuery = {};
        vm.filterOrderBag = filterOrderBag;
        vm.getIntakeData = getIntakeData;
        vm.checkIfSubscriptionIsExpired = checkIfSubscriptionIsExpired;
        vm.hasSubscription = true;
        vm.servants = [];
        vm.goToVideoCall = goToVideoCall;
        vm.goToVideoCallEvent = goToVideoCallEvent;
        vm.filterOrderBag_Global = filterOrderBag_Global;
        vm.advancedSearch = advancedSearch;
        vm.searchKeyPress = searchKeyPress;
        vm.statusList = [1, 4, 5, 6];
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.pageSizeChanged = pageSizeChanged;
        vm.goToCustomerDetail = goToCustomerDetail;


        vm.isSearching = false;
        vm.editReserve = editReserve;
        vm.newReserve = newReserve;
        vm.clearSearch = clearSearch;
        vm.goToCustomerDetailV2 = goToCustomerDetailV2;
        vm.goToCustomerDetailV3 = goToCustomerDetailV3;
        vm.showFilterDialog = showFilterDialog;
        vm.filterCount = 0;
        vm.showEducation = showEducation;
        vm.serviceItems = null;
        vm.getQueryParams = getQueryParams;
        var initialPageLoaded = false;
        
        $scope.filters = QueryParamsService.getFilters();
        vm.page = parseInt(QueryParamsService.getFilters().page || 1);
        loaddata();


        var ShowIntakeDataDialogController = function ($scope, $mdDialog, dialogData) {
            var $ctrl = this;
            $ctrl.orderbag = dialogData;
        };
        ShowIntakeDataDialogController.$inject = ['$scope', '$mdDialog', 'dialogData'];

        function showIntakeData(orderbag) {
            $mdDialog.show({
                locals: {dialogData: orderbag},
                controller: ShowIntakeDataDialogController,
                templateUrl: 'app/entities/order-bag/intake-data-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: orderbag,
                clickOutsideToClose: true,
                fullscreen: false// Only for -

            })
                .then(function (answer) {

                }, function () {
                });
        }

        // function loadPage(page) {
        //     console.log('pageeeeeee', page)
        //     debugger
        //     vm.page = page;
        //     vm.transition();


        // }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getReservePagesByQuery(vm.filterQuery);
            else
                getReservePagesByQuery();

        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            if (vm.isSearching)
                return;
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }

        function findStatusTitle(status) {
            var result = "";
            result = $translate.instant("tikonApp.orderBag.status." + status);
            return result;
        }

        function findStatusStyle(status) {
            return "order-bag-status-" + status;
        }


        function loaddata() {
            // vm.checkIfSubscriptionIsExpired();
            vm.filterQuery.fromDate = new Date();

            vm.servants = ServantCustom.findServantsByCompany().query();
            getQueryParams();
            vm.filterOrderBag();
        }

        function loadAll() {
            vm.orderBagServiceItems = OrderBagServiceItemCustom.getAllOrderBagServiceItemByCurrentCompany().query();
        }

        function refresh() {
            vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromNow().query();
            filterItems();
        }

        function checkIfSubscriptionIsExpired() {
            CompanySubscriptionStatusCustom.canCurrentCompanyReserve(1821).query(function (res) {
                vm.hasSubscription = res;
                // let expireDate = new Date(res.expireDate);
                // let fifteenDaysLater = new Date();
                // fifteenDaysLater.setDate(fifteenDaysLater.getDate() + 15);
                // if (expireDate > fifteenDaysLater) {
                //     vm.hasSubscription = false;
                // } else {
                //     vm.hasSubscription = true;
                // }
            })
        }

        function searchOrderBag() {
            // var fromDateTime = null;
            // var toDateTime = null;
            //
            // if ((vm.fromDateFilter == null || vm.fromDateFilter == undefined)
            //     &&
            //     (vm.toDateFilter == null || vm.toDateFilter == undefined)
            // ) {
            //     loaddata();
            //     return;
            // }
            //
            //
            // if (vm.fromDateFilter == null || vm.fromDateFilter == undefined)
            //     fromDateTime = new Date(2000, 1, 1);
            // else
            //     fromDateTime = new Date(vm.fromDateFilter.toString());
            // if (vm.toDateFilter == null || vm.toDateFilter == undefined)
            //     toDateTime = new Date(3000, 1, 1);
            // else
            //     toDateTime = new Date(vm.toDateFilter.toString());
            //
            //
            // //fromDateTime.setUTCHours(0,0,0);
            // //toDateTime.setUTCHours(0,0,0);
            //
            // vm.orderBagServiceItems = OrderBagServiceItemCustom.getOrderBagServiceItemByCompanyIdFromDateToDate(DateUtils.convertToISOString(fromDateTime), DateUtils.convertToISOString(toDateTime)).query();
            // vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
            //
            // vm.searchBoxOnMobile = false;

        }

        function getIntakeData(customerId) {

            CompanyCustomerCustom.getCompanyCustomerByCustomerId(customerId).query().$promise.then(function (result) {
                CompanyCustomer.get({id: result[0].companyCustomerId}).$promise.then(function (CompanyCustomer) {
                    vm.companyCustomer = CompanyCustomer;
                    vm.companyCustomer.formsData = result;
                });
            });


        }

        function getQueryParams() {
            var newFilters = QueryParamsService.getFilters();
            // if(newFilters.page){
            //     vm.filterQuery.pageNumber = newFilters.page;
            //     vm.page = parseInt(newFilters.page);
            // }
            if (newFilters.page) {
                vm.filterQuery.pageNumber = parseInt(newFilters.page, 10) - 1;
                vm.page = parseInt(newFilters.page, 10);
                }
       
            if(newFilters.pageSize){
                vm.filterQuery.pageSize = newFilters.pageSize;
                vm.pageSize = newFilters.pageSize;
            }
            if(newFilters.searchText){
                vm.filterQuery.searchText = newFilters.searchText;
            }
            if(newFilters.fromDate){
                vm.filterQuery.fromDate = newFilters.fromDate;
            }
            if(newFilters.toDate){
                vm.filterQuery.toDate = newFilters.toDate;
            }
            if(newFilters.servantIds){
                vm.filterQuery.servantIds = newFilters.servantIds;
            }
            if(newFilters.serviceItemIds){
                vm.filterQuery.serviceItemIds = newFilters.serviceItemIds;
            }
            if(newFilters.status){
                vm.filterQuery.status = newFilters.status;
            }
            if(newFilters.filterQuery) {
                setFilterQuery(JSON.parse(decodeURIComponent(newFilters.filterQuery)))
            }
        }

        function filterOrderBag(customFilter) { 
            if (vm.isSearching)
                return;
            getReservePagesByQuery(customFilter);
        }

        function advancedSearch() {
            clear();
            vm.filterQuery.searchMode = true;
            vm.filterQuery.dontFilterFromDate = false;
            filterOrderBag();
        }


        function filterOrderBag_Global() {
            if (vm.filterQuery.searchText) {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = true;
                QueryParamsService.updateFilter('searchText', vm.filterQuery.searchText)
            } else {
                vm.filterQuery.searchMode = true;
                vm.filterQuery.dontFilterFromDate = false;
                QueryParamsService.removeFilter('searchText')
            }
            filterOrderBag();
            clear();

        }

        function reserveGatewayToPersian(gate) {
            return gate;
        }

        function getMonthCount(orderBagServiceItem) {

            var count = 0;
            var fromDate = new Date(orderBagServiceItem.serviceTimeSession.startDate);
            var endDate = new Date(orderBagServiceItem.serviceTimeSession.endDate);
            while (fromDate < endDate) {
                count = count + 1;
                fromDate.setDate(fromDate.getDate() + (30));
            }

            return count;
        }

        function showSearchBoxOnMobile() {
            vm.searchBoxOnMobile = !vm.searchBoxOnMobile;
        }

        function serviceItem_changed() {

            filterItems();
        }

        function status_changed() {
            filterItems();
        }

        function filterItems() {

            vm.orderBagServiceItems = vm.orderBagServiceItemsQuery;
            if ((vm.serviceItemId == "" || vm.serviceItemId == undefined) && (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)) {
                return;
            }

            vm.orderBagServiceItems = vm.orderBagServiceItems.filter(function (item) {

                if (vm.orderBagStatus == "" || vm.orderBagStatus == undefined)
                    return ((item.serviceItem.id == vm.serviceItemId));
                if (vm.serviceItemId == "" || vm.serviceItemId == undefined)
                    return ((item.orderBag.status == vm.orderBagStatus));

                return (item.orderBag.status == vm.orderBagStatus
                    &&
                    item.serviceItem.id == vm.serviceItemId
                );
            })
        }

        function showDateSearch() {
            vm.showSearchByDates = !vm.showSearchByDates;
        }

        function showSearchTextBoxOnMobile() {
            vm.searchTextBoxOnMobile = !vm.searchTextBoxOnMobile;
        }

        function searchOrderBagByQuery() {

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItems;
            if (vm.searchQuery == null || vm.searchQuery == undefined || vm.searchQuery == "") {
                //vm.companyCustomerQueryList = vm.companyCustomers;
                return;
            }

            vm.orderBagServiceItemsQuery = vm.orderBagServiceItemsQuery.filter(function (item) {

                return ((item.orderBag.customer.personalInfo.fisrtName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.lastName.includes(vm.searchQuery))
                    || (item.orderBag.customer.personalInfo.phoneNumber.includes(vm.searchQuery))
                    || (item.serviceItem.itemTitle.includes(vm.searchQuery))
                );
            })


        }

        function goToVideoCall(orderBagItem) {

            $mdDialog.show({
                controller: 'JoinVideoMeetingComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting/partial-form.join-video-meeting.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            orderBagItem: orderBagItem
                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function onCreateMeetingSuccess(result) {

            if (result.joinMeetingURL) {
                $window.open(result.joinMeetingURL, "_blank");
            }

        }

        function onCreateMeetingFailed() {

        }

        function onJoinSuccess(result) {
            if (result.joinMeetingURL) {
                $window.open(result.joinMeetingURL, "_blank");
            }
        }

        function onJoinError() {

        }

        function findMeetingPassword(orderBagItem) {
            return orderBagItem.servant.id;
        }

        function goToVideoCallEvent(orderBagItem) {

            $mdDialog.show({
                controller: 'JoinVideoMeetingEventComponentController',
                templateUrl: 'app/components/partial-forms/join-video-meeting-event/partial-form.join-video-meeting-event.html',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            serviceItem: orderBagItem.serviceItem,
                            servant: orderBagItem.servant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            })
                .then(function (answer) {

                    // $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    // $scope.status = 'You cancelled the dialog.';
                });

        }


        function getReservePagesByQuery(customFilter) {
            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;
            // if(isTransition)
            //     filterQuery.pageNumber = vm.page;

            //must set in cache
            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;
            searchOrderBagItemsByQueryPage(filterQuery)

         
        }
        function searchOrderBagItemsByQueryPage(filterQuery) {
            OrderBagServiceItemCustom.searchOrderBagItemsByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orderBagServiceItems = data;
                vm.isSearching = false;

                gotToTop();
                // vm.page = vm.filterQuery.pageNumber+1;
                //test MAJID
            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                filterOrderBag_Global();
            }
        }

        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function pageSizeChanged() {
            QueryParamsService.updateFilter('pageSize', vm.pageSize)
            clear();
            filterOrderBag();
        }

        function goToCustomerDetail(customerId) {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(customerId).query().$promise.then(onGetCustomerSuccess);
                    }
                });
        }
        function goToCustomerDetailV3(customerId){
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
            .then(function (result) {
                if (result) {
                    CompanyCustomerCustom.findCompanyCustomerByCustomerId(customerId).query().$promise.then(showCustomerModal);
                }
            });
        }

        function onGetCustomerSuccess(result) {

            var companyCustomer = result;
            showCustomerPopUp(companyCustomer.id);
            // $state.transitionTo('supplierPanel.companyCustomerPopUp', {id: });

        }
        function showCustomerModal(companyCustomerEntity) {
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');

            $mdDialog.show({
                templateUrl:
                    'app/entities/company-customer/company-customer-detailV2.html',
                controller: [
                    '$scope',
                    '$mdDialog',
                    'companyCustomerEntity',
                    function ($scope, $mdDialog, companyCustomerEntity) {
                        $scope.companyCustomerEntity = companyCustomerEntity;

                        $scope.close = function () {
                            $mdDialog.cancel();
                        };

                        $scope.viewDetails = function () {
                            $mdDialog.hide(companyCustomerEntity);
                        };
                    }
                ],
                locals: {
                    companyCustomerEntity: companyCustomerEntity
                },
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(
                function (res) {
                    goToCustomerDetailV2(res.customer.id)
                },
                function () {
                }
            );
        }


        function showCustomerPopUp(companyCustomerId) {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                controller: 'CompanyCustomerPopUpController',
                controllerAs: 'vm',
                backdrop: 'true',
                size: 'lg',

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', function (CompanyCustomer) {
                        return CompanyCustomer.get({id: companyCustomerId}).$promise;
                    }],
                    formData: {
                        mode: 'EDIT',
                        isPopUp: true
                    }
                }
            }).result.then(function (v) {
                reload();
            }, function () {
                //nothing
            });
        }

        function editReserve(orderBagServiceItem) {
            $state.go('supplierPanel-v2.editOrderBag', {id: orderBagServiceItem.orderBag.id})
        }

        function newReserve() {
            $state.go('supplierPanel-v2.newReserve')
        }


        function clearSearch() {
            vm.filterQuery.searchText = null;
            filterOrderBag_Global();
             QueryParamsService.removeFilter('searchText')
        }

        function goToCustomerDetailV2(customerId) {
            Principal.hasAuthority("ROLE_CUSTOMER_MANAGER")
                .then(function (result) {
                    if (result) {
                        CompanyCustomerCustom.findCompanyCustomerByCustomerId(customerId).query().$promise.then(onGetCustomerSuccessV2);
                    }
                });
        }

        function onGetCustomerSuccessV2(result) {
            var companyCustomer = result;
            $state.go('supplierPanel-v2.companyCustomer.edit', {id: companyCustomer.id});
        }


        var ShowFilterDialogController = function ($scope, $mdDialog, dialogData, $mdSelect) {
            var $ctrl = this;
            $ctrl.data = dialogData;
            $ctrl.okModal = okModal;
            $ctrl.closeModal = closeModal;
            $ctrl.clearFilter = clearFilter;


            //for closing the select box
            document.body.onclick = function (e) {
                $mdSelect.hide();
            }

            function okModal() {
                $mdDialog.hide($ctrl.data);
            }

            function closeModal() {
                $mdDialog.cancel();
            }

            function clearFilter() {
                $ctrl.data.filterQuery = {};
                $ctrl.data.filterQuery.fromDate = new Date();
            }

        };
        ShowFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', '$mdSelect'];

        function showFilterDialog() {
            if(!vm.serviceItems) {
                ProgressBarService.show();
                ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.serviceItems = result;
                    dialogData_.serviceItems = result;
                    ProgressBarService.hide();
                })
            }
            var dialogData_ = {};
            dialogData_.serviceItems = vm.serviceItems;
            dialogData_.statusList = vm.statusList;
            dialogData_.filterQuery = vm.filterQuery;
            dialogData_.servants = vm.servants;


            $mdDialog.show({
                locals: {dialogData: dialogData_},
                controller: ShowFilterDialogController,
                templateUrl: 'app/entities/reserve/filter-reserve-list-dialog.html',
                controllerAs: '$ctrl',
                parent: angular.element(document.body),
                targetEvent: dialogData_,
                clickOutsideToClose: true,
                size: 'lg',
                fullscreen: false

            })
            .then(function (data) {
                setFilterQuery(data.filterQuery, true);
                QueryParamsService.updateFilter('filterQuery', encodeURIComponent(JSON.stringify(data.filterQuery)))
                vm.advancedSearch();
            }, function () {
            });
        }

        function setFilterQuery(filter, ignorSearchText) {
            var shallowFilter = filter
            if(ignorSearchText &&  shallowFilter.searchText) delete shallowFilter.searchText
            // vm.filterQuery = filter;
            angular.extend(vm.filterQuery, filter);
            countFilters();
        }

        function countFilters() {
            vm.filterCount = 0;
            var date = new Date();
            if (vm.filterQuery.fromDate && new Date(vm.filterQuery.fromDate).getDate() != date.getDate())
                vm.filterCount++;
            if (vm.filterQuery.toDate)
                vm.filterCount++;
            if (vm.filterQuery.status && vm.filterQuery.status.length > 0)
                vm.filterCount++;
            if (vm.filterQuery.serviceItemIds && vm.filterQuery.serviceItemIds.length > 0)
                vm.filterCount++;
            if (vm.filterQuery.servantIds && vm.filterQuery.servantIds.length > 0)
                vm.filterCount++;
            if (vm.filterQuery.orderBagId)
                vm.filterCount++;
            if(vm.filterCount < 1) 
                QueryParamsService.removeFilter('filterQuery')
        }
          function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                         return '<div id="38624689961"><script type="text/JavaScript" src="https://www.aparat.com/embed/cjzfc06?data[rnddiv]=38624689961&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>';
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

    }
})();
